// this file is generated by update_shopify_store_data.py at 2026-11-03 20:16:43.536750
var courses = [
    {
        "course_id": "A669607B-29D1-F011-99A4-005056A7327D",
        "course_version": 2,
        "name": "Springer Publishing - PMH-BC\u2122 Certification Online Review",
        "course_type": 1,
        "author_information": "Springer Publishing",
        "description": "Prepare for the Psychiatric-Mental Health Nursing (PMH-BC\u2122) certification exam with a comprehensive online review aligned to the latest exam outline. This course features learning modules with audio narration, knowledge check questions, and a full-length practice test to strengthen test-taking skills and boost exam-day confidence. \r\n\r\nPMH-BC\u2122 is a registered trademark of the American Nurses Credentialing Center (ANCC). The ANCC does not endorse this resource, nor does it have a proprietary relationship with Springer Publishing Company.",
        "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Describe key concepts and clinical knowledge areas related to psychiatric&ndash;mental health nursing practice.</li>\r\n    <li>Apply critical-thinking and therapeutic communication skills to patient-care scenarios across diverse mental health conditions.</li>\r\n    <li>Demonstrate readiness for the PMH-BC&trade; certification exam through self-assessment activities.</li>\r\n</ul>",
        "course_outline_html": "<li>Introduction</li>\r\n<li>Module 1: Certification Exam</li>\r\n<li>Module 2: Psychiatric-Mental Health Nursing</li>\r\n<li>Module 3: Fundamental Theories of Mental Illness and Nonpharmacological Intervention</li>\r\n<li>Module 4: Neuroanatomy, Physiology, and Psychopharmacology</li>\r\n<li>Module 5: Substance User Disorders and Addiction</li>\r\n<li>Module 6: Cognitive Disorders</li>\r\n<li>Module 7: Psychotic Disorders</li>\r\n<li>Module 8: Sleep Disorders</li>\r\n<li>Module 9: Mood Disorders</li>\r\n<li>Module 10: Anxiety and Related Disorders</li>\r\n<li>Module 11: Child/Adolescent and Developmental Disorders</li>\r\n<li>Module 12: Personality Disorders</li>",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "2A010654-ECD9-F011-99A4-005056A7F5E9",
                "course_category_name": "Springer Publishing - Single Courses for Purchase (NGL)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "ED7E45AB-9782-E211-B22E-0015171C1A75",
                "course_category_name": "Psychiatric Disorders",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C33B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Procedures",
                "is_system_course_category": null
            },
            {
                "course_category_id": "30C21A06-4DBA-F011-99A1-005056A7C0C7",
                "course_category_name": "Springer Publishing",
                "is_system_course_category": null
            },
            {
                "course_category_id": "45A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Psychiatry",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D0B2F3ED-33D4-E511-93E1-005056B12CFE",
                "course_category_name": "Psychosocial Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EB0C13C7-0116-EA11-8041-005056B15B8C",
                "course_category_name": "All Settings",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3DA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Professional Development",
                "is_system_course_category": null
            },
            {
                "course_category_id": "66608656-21BB-F011-99A1-005056A7C0C7",
                "course_category_name": "Springer Publishing",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": []
    }
];